import { ref, set, get, child, update, remove } from "firebase/database";
import { database } from "./firebase";

export const dbService = {
    // Write user data
    writeUserData: async (userId, userData) => {
        await set(ref(database, 'users/' + userId), userData);
    },

    // Get user data
    getUserData: async (userId) => {
        const dbRef = ref(database);
        const snapshot = await get(child(dbRef, `users/${userId}`));
        if (snapshot.exists()) {
            return snapshot.val();
        } else {
            return null;
        }
    },

    // Update user data
    updateUserData: async (userId, updates) => {
        await update(ref(database, 'users/' + userId), updates);
    },

    // Save survey data
    saveSurveyData: async (userId, surveyData) => {
        await set(ref(database, 'surveys/' + userId), surveyData);
    },

    // Get survey data
    getSurveyData: async (userId) => {
        const dbRef = ref(database);
        const snapshot = await get(child(dbRef, `surveys/${userId}`));
        if (snapshot.exists()) {
            return snapshot.val();
        } else {
            return null;
        }
    },

    // Generic write
    write: async (path, data) => {
        await set(ref(database, path), data);
    },

    // Generic read
    read: async (path) => {
        const dbRef = ref(database);
        const snapshot = await get(child(dbRef, path));
        return snapshot.exists() ? snapshot.val() : null;
    }
};